import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import MessageThreads from '../parts/MessageThreads';
import MessageThreadMessages from '../parts/MessageThreadMessages';

const styles = theme => ({
  container: {
    height: 'calc(100vh - 64px)', // 64px is the height of the app bar
  },
  threadsWrapper: {
    height: '100%',
    overflow: 'auto',
    width: 320,
  },
  threadMessagesWrapper: {
    overflow: 'hidden',
    height: '100%',
    background: '#fafafa',
    flexGrow: 1,
    flex: 1,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class DesktopMessagesPage extends React.Component {
  render() {
    const {
      classes,
      t,
      selectedPupil,
    } = this.props;

    const apiUrl = `${window.apiMessagingUrl}/getteacherstomessage`;
    const apiParams = {
      pupil_id: selectedPupil
        ? selectedPupil.id
        : 0,
    };

    return (
      <div className="desktop-messages-page">
        <Grid
          container
          className={classes.container}
        >
          <Grid
            item
            className={classes.threadsWrapper}
          >
            <MessageThreads
              apiUrl={apiUrl}
              apiParams={apiParams}
              listType="teacher"
              useSuspense={false}
            />
          </Grid>
          <Grid
            item
            className={classes.threadMessagesWrapper}
          >
            <MessageThreadMessages useSuspense={false} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(DesktopMessagesPage))
);
